@use '@lib/assets/styles/main.scss' as *;

.root {
  display: flex;
  align-items: flex-start;
}

.actions {
  padding-left: 20px;
  gap: 0 4px;
  display: flex;
  margin: -4px 0 -4px auto;
}
